export default __webpack_public_path__ + "static/media/ejsLogo.41ee8cc4.svg";